import { render, staticRenderFns } from "./TestService.vue?vue&type=template&id=130f0766"
import script from "./TestService.vue?vue&type=script&lang=js"
export * from "./TestService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports